// Reviews section controls. The arrows drive Judge.me's Cards Carousel, and "Write a review" opens Judge.me's
// own form, so Judge.me keeps handling the data while the controls sit where the redesign puts them.
document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-bg-rev]');
  if (!control) return;
  const root = control.closest('.bg-reviews');
  if (!root) return;
  const action = control.dataset.bgRev;

  if (action === 'prev' || action === 'next') {
    const arrows = root.querySelectorAll('.jdgm-arrow');
    const label = action === 'prev' ? 'Previous slide' : 'Next slide';
    const target = root.querySelector(`.jdgm-arrow[aria-label="${label}"]`) || arrows[action === 'prev' ? 0 : arrows.length - 1];
    target?.click();
  }

  if (action === 'write') {
    const write = root.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
    if (write) {
      write.click();
    } else {
      root.querySelector('.bg-rev-app')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
});
